import { DvaReducer, WholeReadonly } from '@/models/shared';
import { AnyAction, Dispatch } from 'umi';
import { EffectsCommandMap, Subscription } from 'dva';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import { ConnectState } from './connect';

interface IUserInfo {
  createDate: string;
  email: string;
  headImage: string;
  mobile: string;
  status: number;
  tokenSn: string;
  userDetail: {
    sex: 0 | 1 | 2;
    birthday: string;
    occupation: string;
    areaCode: string;
    areaName: string;
    latestLoginDate: string;
    latestLoginIp: string;
    resourceCount: number;
    reason: string;
    remark: string;
    intro: string;
    statusChangeRemark: string;
    createDate: string;
    updateDate: string;
  };
  userId: number;
  userType: 0 | 1;
  username: string;
}

export interface UserModelState {
  isReady: boolean;
  userInfo: null | IUserInfo;
  isLogin: boolean;
  isFreeze: boolean;
  isAlphaTest: boolean;
}

export interface SubscriptionAPI {
  history: History;
  dispatch: Dispatch;
}

export interface ChangeAction extends AnyAction {
  type: 'change' | 'user/change';
  payload: Partial<UserModelState>;
}

export interface FetchInfoAction extends AnyAction {
  type: 'fetchInfo' | 'user/fetchInfo';
}

interface UserModelType {
  namespace: 'user';
  state: UserModelState;
  effects: {
    fetchInfo: (action: FetchInfoAction, effects: EffectsCommandMap) => void;
  };
  reducers: {
    change: DvaReducer<UserModelState, ChangeAction>;
  };
  subscriptions: {
    setup: Subscription;
  };
}

const initStates: UserModelState = {
  isReady: false,
  userInfo: null,
  isLogin: FUtil.Tool.getUserIDByCookies() !== -1,
  isFreeze: false,
  isAlphaTest: false,
};

const Model: UserModelType = {
  namespace: 'user',
  state: initStates,
  effects: {
    *fetchInfo({}: FetchInfoAction, { call, put, select }: EffectsCommandMap) {
      const { user }: ConnectState = yield select(({ user }: ConnectState) => ({
        user,
      }));

      if (FUtil.Tool.getUserIDByCookies() === -1) {
        yield put<ChangeAction>({
          type: 'change',
          payload: {
            isReady: true,
            userInfo: null,
            isLogin: false,
            isFreeze: false,
            isAlphaTest: false,
          },
        });
        return;
      }

      const {
        data,
      }: {
        ret: number;
        errCode: number;
        data: IUserInfo;
      } = yield call(FServiceAPI.User.currentUserInfo);

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          isReady: true,
          userInfo: data
            ? {
                ...data,
                headImage: FUtil.Tool.getAvatarUrl(),
              }
            : null,
          isFreeze: data.status === 1,
          isAlphaTest: data.status === 2 || data.status === 3,
        },
      });
    },
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({ dispatch }: SubscriptionAPI) {
      dispatch<FetchInfoAction>({
        type: 'fetchInfo',
      });
    },
  },
};

export default Model;
